import { render } from "./PdfParsingSettingsPage.vue?vue&type=template&id=dd2e9626&scoped=true"
import script from "./PdfParsingSettingsPage.vue?vue&type=script&lang=js"
export * from "./PdfParsingSettingsPage.vue?vue&type=script&lang=js"

import "./PdfParsingSettingsPage.vue?vue&type=style&index=0&id=dd2e9626&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2e9626"]])

export default __exports__